<template>
  <div>
    <SiteBanner :site-address="siteAddressStatic" :site-name="siteNameStatic" />
    <div class="card space-y-6 pb-3">
      <div
        class="flex items-center justify-center space-x-3 rounded-t-md bg-amber-500 py-2"
      >
        <ExclamationTriangleIcon class="h-7 w-7 stroke-white" />
        <h1 class="text-lg text-white">No Access To Site</h1>
      </div>
      <div class="space-y-4 px-4">
        <p class="text-base">
          This phone number is associated with a company that has no access to
          this site. Please contact your company administrator.
        </p>
        <PrimaryButton
          :key="buttonKey"
          action="OK"
          identifier="no-access-to-site-ok-btn"
          @click.once="handleRoute"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import PrimaryButton from '@/components/PrimaryButton.vue'
  import SiteBanner from '@/components/SiteBanner.vue'
  import { resetStoreExceptUser } from '@/components/use/resetStore'
  import { useRouter } from 'vue-router'
  import { storeToRefs } from 'pinia'
  import { useSiteStore } from '@/storage/site'
  import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
  import Log from '@/utilities/Log'

  const { address, name } = storeToRefs(useSiteStore())

  const siteNameStatic = name.value
  const siteAddressStatic = address.value
  const buttonKey = ref(0)
  const router = useRouter()

  Log.storeReset('NoAccessToSite.vue', 'handleRoute')
  resetStoreExceptUser()

  async function handleRoute() {
    buttonKey.value++
    await router.replace({ name: 'selectNearbySite' })
  }
</script>
